import config from 'config';
import { Button, Text } from 'AppStyles';
import { Container } from './Styles';

const UserNotFound = () => {
  const { redirector } = config;
  return (
    <Container>
      <Text>We couldn't find your user.</Text>
      <Text $weight={600}> Please log in to the game with your Facebook account.</Text>
      <Text>Then come back here and login to the store.</Text>
      <Button $isModal onClick={() => window.open(redirector)}>
        Open App
      </Button>
    </Container>
  );
};

export default UserNotFound;
